/**
 * Shared mobile style overrides.
 *
 * MOBILE_FULL_BUTTON makes a header action button fill its row on phones —
 * applied as `...(isMobile ? MOBILE_FULL_BUTTON : {})` on top of the brand
 * primary / secondary button styles so full-width buttons keep identical
 * heights. The explicit height makes bordered secondary and borderless
 * primary buttons line up exactly.
 *
 * Promoted here from identical per-page copies in AdesaRunListPage and
 * AdesaClearedListPage when the Daily Photo List became the third consumer.
 */
import type { CSSProperties } from "react"

import { THEME } from "./theme"

export const MOBILE_FULL_BUTTON: CSSProperties = {
  flex: "1 1 0",
  minWidth: 0,
  height: 40,
  boxSizing: "border-box",
  padding: `0 ${THEME.spacing.sm}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}
